module.exports = __webpack_public_path__ + "static/img/posco-safety-consulting.8bc1c5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/posco-safety-consulting.jpg
// module id = jx8L
// module chunks = 0